import { Text, Link } from '@comicrelief/component-library';

const CopyBottom = (
  <Text tag="p" color="grey_dark" size="xs">
    Update your preferences at any time by visiting our
    {' '}
    <Link
      type="standard"
      href="https://www.comicrelief.com/update-your-preferences"
      target="blank"
    >
      preferences centre
    </Link>
    . Your details will be kept safe, see our
    {' '}
    <Link type="standard" href="https://www.comicrelief.com/privacy-policy" target="blank">
      privacy policy
    </Link>
    {' '}
    for more information.
  </Text>
);

export default CopyBottom;
